/* Tecnosoluciones – interacciones: carrito lateral, buscador predictivo,
   carruseles, contador de ofertas y aparición al hacer scroll. */
(function () {
  'use strict';
  window.tsInteractive = true;

  var cfgEl = document.querySelector('[data-ts-config]');
  var cfg = cfgEl ? cfgEl.dataset : {};
  var root = cfg.root || '/';
  var SECTION = 'ts-cart-drawer';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function sectionHTML(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var s = d.querySelector('.shopify-section');
    return s ? s.innerHTML : d.innerHTML;
  }
  function jsonResponse(r) {
    return r.json().then(function (j) { return { ok: r.ok, j: j }; });
  }

  /* ---------- 1. Carrito lateral ---------- */
  var drawer = document.getElementById('TsCartDrawer');
  var content, msg, panel, lastFocus;
  if (drawer) {
    document.body.appendChild(drawer);
    content = $('[data-ts-cart-content]', drawer);
    msg = $('[data-ts-cart-msg]', drawer);
    panel = $('.ts-cd-panel', drawer);
  }

  function setCount(n) { $$('[data-ts-count]').forEach(function (el) { el.textContent = n; }); }
  function render(html) {
    if (!content) return;
    content.innerHTML = sectionHTML(html);
    var b = $('[data-count]', content);
    if (b) setCount(b.getAttribute('data-count'));
    // Si estamos en la página del carrito, también se actualiza el resumen de la página.
    document.dispatchEvent(new CustomEvent('ts:cart-updated'));
  }
  function showMsg(text, ok) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'ts-cd-msg' + (ok ? ' ok' : '');
    msg.hidden = !text;
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('ts-lock');
    panel.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ts-lock');
    setTimeout(function () { drawer.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refresh() {
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[SECTION]); })
      .catch(function () { showMsg('No pudimos cargar el carrito. Recarga la página.'); });
  }
  function change(key, qty) {
    content.classList.add('ts-cd-busy');
    fetch(cfg.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION })
    })
      .then(jsonResponse)
      .then(function (res) {
        if (!res.ok) { showMsg(res.j.description || res.j.message || 'No se pudo actualizar el carrito.'); return refresh(); }
        showMsg('');
        if (res.j.sections && res.j.sections[SECTION]) render(res.j.sections[SECTION]); else return refresh();
      })
      .catch(function () { showMsg('Revisa tu conexión e inténtalo de nuevo.'); })
      .then(function () { content.classList.remove('ts-cd-busy'); });
  }

  document.addEventListener('click', function (e) {
    if (!drawer) return;
    if (e.target.closest('[data-ts-cart-open]')) { e.preventDefault(); showMsg(''); openDrawer(); refresh(); return; }
    if (e.target.closest('[data-ts-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    var q = e.target.closest('[data-ts-qty]');
    if (q && drawer.contains(q)) {
      var li = q.closest('[data-key]');
      if (li) change(li.getAttribute('data-key'), parseInt(q.getAttribute('data-ts-qty'), 10));
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form.ts-add');
    if (!f || !drawer || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = $('button[type="submit"]', f), txt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
    var fd = new FormData(f);
    fd.append('sections', SECTION);
    fetch(cfg.cartAdd + '.js', {
      method: 'POST', body: fd, credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(jsonResponse)
      .then(function (res) {
        openDrawer();
        if (!res.ok) { showMsg(res.j.description || 'No se pudo agregar este producto.'); return refresh(); }
        showMsg('Producto agregado al carrito.', true);
        if (res.j.sections && res.j.sections[SECTION]) render(res.j.sections[SECTION]); else return refresh();
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = txt; } });
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input:not([type="hidden"]),[tabindex]:not([tabindex="-1"])', panel)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- 2. Buscador predictivo ---------- */
  $$('[data-ts-ps-form]').forEach(function (form) {
    var input = $('input[type="search"]', form), box = $('[data-ts-ps]', form), timer, ctl, lastQ = '';
    if (!input || !box || !cfg.psUrl) return;
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (q === lastQ && box.innerHTML) { open(); return; }
        lastQ = q;
        if (ctl) ctl.abort();
        ctl = window.AbortController ? new AbortController() : null;
        var url = cfg.psUrl + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' +
          // Sugerencias más precisas: busca en nombre, tipo, marca, variante, referencia (SKU) y etiquetas, no en la descripción larga.
          '&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku,tag' +
          '&section_id=ts-predictive-search';
        fetch(url, { signal: ctl ? ctl.signal : undefined })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (input.value.trim() !== q) return;
            box.innerHTML = sectionHTML(html);
            if (box.textContent.trim()) open(); else close();
          })
          .catch(function () {});
      }, 250);
    });
    input.addEventListener('focus', function () { if (box.innerHTML.trim() && input.value.trim().length >= 2) open(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = $$('a', box);
      if (box.hidden || !items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? items.length - 1 : i - 1);
      items[i].focus();
    });
  });

  /* ---------- 3. Filas de productos tipo carrusel ---------- */
  function initRows(scope) {
    $$('[data-ts-row]', scope).forEach(function (sec) {
      if (sec.dataset.tsReady) return;
      sec.dataset.tsReady = '1';
      var tr = $('[data-ts-track]', sec), prev = $('[data-ts-prev]', sec), next = $('[data-ts-next]', sec), nav = $('.ts-nav', sec);
      if (!tr || !prev || !next) return;
      function upd() {
        var max = tr.scrollWidth - tr.clientWidth - 2;
        nav.hidden = max <= 0;
        prev.disabled = tr.scrollLeft <= 2;
        next.disabled = tr.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { tr.scrollBy({ left: -tr.clientWidth, behavior: 'smooth' }); });
      next.addEventListener('click', function () { tr.scrollBy({ left: tr.clientWidth, behavior: 'smooth' }); });
      tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- 5. Contador de ofertas (hora de Colombia, UTC-5) ---------- */
  var CO = 5 * 3600 * 1000;
  function endFor(el) {
    if (el.dataset.mode === 'weekly') {
      var n = new Date(Date.now() - CO), add = (7 - n.getUTCDay()) % 7;
      return Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate() + add, 23, 59, 59) + CO;
    }
    var m = (el.dataset.end || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return 0;
    var hasTime = m[4] !== undefined;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59) + CO;
  }
  function initCountdowns(scope) {
    $$('[data-ts-countdown]', scope).forEach(function (el) {
      if (el.dataset.tsReady) return;
      el.dataset.tsReady = '1';
      var end = endFor(el);
      if (!end) return;
      var d = $('[data-d]', el), h = $('[data-h]', el), mi = $('[data-m]', el), s = $('[data-s]', el), iv;
      function pad(x) { return (x < 10 ? '0' : '') + x; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          if (el.dataset.mode === 'weekly') { end = endFor(el); return; }
          el.hidden = true; clearInterval(iv); return;
        }
        el.hidden = false;
        d.textContent = Math.floor(left / 86400);
        h.textContent = pad(Math.floor(left % 86400 / 3600));
        mi.textContent = pad(Math.floor(left % 3600 / 60));
        s.textContent = pad(left % 60);
      }
      iv = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- 6. Aparición suave al hacer scroll ---------- */
  function initReveal(scope) {
    if (!document.documentElement.classList.contains('ts-js')) return;
    var els = $$('.ts-reveal:not(.ts-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(function (x) { x.classList.add('ts-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('ts-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (x) { io.observe(x); });
  }

  /* ---------- Franja de confianza rotativa en celular ---------- */
  function initTrust(scope) {
    $$('.ts-trust', scope).forEach(function (bar) {
      if (bar.dataset.tsReady) return;
      bar.dataset.tsReady = '1';
      var items = $$('.ts-w > span', bar), i = 0, iv;
      if (items.length < 2) return;
      var mq = window.matchMedia('(max-width: 749px)');
      function show() { items.forEach(function (x, j) { x.classList.toggle('on', j === i); }); }
      function apply() {
        clearInterval(iv);
        if (mq.matches) {
          bar.classList.add('ts-rot'); show();
          if (!matchMedia('(prefers-reduced-motion: reduce)').matches) iv = setInterval(function () { i = (i + 1) % items.length; show(); }, 3500);
        } else { bar.classList.remove('ts-rot'); }
      }
      if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
      apply();
    });
  }

  /* ---------- Página de producto ---------- */
  function initPdp(scope) {
    $$('[data-ts-pdp]', scope).forEach(function (root) {
      if (root.dataset.tsReady) return;
      root.dataset.tsReady = '1';

      // Galería
      var stage = $('[data-ts-stage]', root), slides = $$('.ts-mslide', root);
      var thumbs = $$('.ts-thumbs button', root), dots = $$('.ts-gdots button', root), cur = 0;
      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (sl, j) { sl.classList.toggle('is-on', j === cur); });
        thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === cur); });
        dots.forEach(function (b, j) { b.setAttribute('aria-current', j === cur); });
        if (stage) stage.classList.remove('is-zoom');
      }
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      dots.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      if (stage) {
        var x0 = null;
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
          x0 = null;
        });
        if (window.matchMedia && matchMedia('(hover: hover) and (min-width: 981px)').matches) {
          stage.addEventListener('mousemove', function (e) {
            var img = $('.ts-mslide.is-on img', stage);
            if (!img) return;
            var r = stage.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
            stage.classList.add('is-zoom');
          });
          stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
        }
      }

      // Cantidad
      var qi = $('[data-ts-qty-input]', root);
      $$('[data-ts-q]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qi) return;
          qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-ts-q'), 10));
        });
      });

      // Pestañas
      var tabs = $$('[role="tab"]', root);
      function sel(t) {
        tabs.forEach(function (x) {
          var on = x === t, pn = document.getElementById(x.getAttribute('aria-controls'));
          x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
          if (pn) pn.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!k) return;
          var n = tabs[(i + k + tabs.length) % tabs.length]; sel(n); n.focus();
        });
      });

      // Variantes
      var vj = $('[data-ts-variants]', root), vs = $('[data-ts-vsel]', root);
      if (vj && vs) {
        var vars = [];
        try { vars = JSON.parse(vj.textContent); } catch (err) {}
        vs.addEventListener('change', function () {
          var vr = null;
          vars.forEach(function (x) { if (String(x.id) === vs.value) vr = x; });
          if (!vr) return;
          $('[data-ts-vid]', root).value = vr.id;
          $('[data-ts-price]', root).innerHTML = '<span class="ts-now">' + vr.price + '</span>' +
            (vr.compare ? '<span class="ts-was">' + vr.compare + '</span><span class="ts-save">Ahorras ' + vr.save + ' (-' + vr.pct + '%)</span>' : '');
          var sp = $('[data-ts-sticky-price]', root); if (sp) sp.textContent = vr.price;
          var st = $('[data-ts-stock]', root);
          if (st) st.innerHTML = !vr.available ? '<span class="ts-stock is-out">Agotado</span>' :
            (vr.low ? '<span class="ts-stock is-low">¡Queda' + (vr.low > 1 ? 'n ' : ' ') + vr.low + '!</span>' : '<span class="ts-stock">Disponible</span>');
          $$('.ts-padd', root).forEach(function (b) { b.disabled = !vr.available; b.textContent = vr.available ? 'Agregar al carrito' : 'Agotado'; });
          if (typeof vr.m === 'number' && vr.m >= 0 && vr.m < slides.length) show(vr.m);
          if (window.history && history.replaceState) {
            var u = new URL(window.location.href); u.searchParams.set('variant', vr.id); history.replaceState({}, '', u.toString());
          }
        });
      }

      // Barra fija en celular
      var sticky = $('[data-ts-psticky]', root), ab = $('[data-ts-addbtn]', root);
      if (sticky && ab) {
        var chk = function () {
          var on = ab.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', on);
          document.documentElement.classList.toggle('ts-has-sticky', on);
        };
        window.addEventListener('scroll', chk, { passive: true });
        chk();
      }
    });
  }

  /* ---------- Productos similares ---------- */
  function initReco(scope) {
    $$('[data-ts-reco]', scope).forEach(function (el) {
      if (el.dataset.tsReady || !el.dataset.url) return;
      el.dataset.tsReady = '1';
      if ($('[data-ts-row]', el)) { initRows(el); return; }
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          var n = d.querySelector('[data-ts-reco]');
          if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; initRows(el); initReveal(el); }
        })
        .catch(function () {});
    });
  }

  /* ---------- Categorías y búsqueda: filtros, orden y "Cargar más" ---------- */
  function initColl(scope) {
    $$('[data-ts-coll]', scope).forEach(function (root) {
      if (root.dataset.tsReady) return;
      root.dataset.tsReady = '1';
      var sid = root.getAttribute('data-section');
      var mqMobile = window.matchMedia ? matchMedia('(max-width: 980px)') : { matches: false };

      function swap(html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var n = d.querySelector('[data-ts-coll]');
        if (!n) return false;
        root.innerHTML = n.innerHTML;
        delete root.dataset.tsReady;
        document.documentElement.classList.remove('ts-lock');
        init(root.parentNode || document);
        return true;
      }
      function load(url, push) {
        root.classList.add('is-loading');
        var u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', sid);
        fetch(u.toString(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            u.searchParams.delete('section_id');
            if (swap(html) && push && window.history) { history.pushState({ ts: 1 }, '', u.pathname + u.search); window.tsPushed = true; }
            var top = root.getBoundingClientRect().top + window.pageYOffset - 140;
            if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
          })
          .catch(function () { window.location.href = url; })
          .then(function () { root.classList.remove('is-loading'); });
      }
      function formUrl(form) {
        var fd = new FormData(form), p = new URLSearchParams();
        fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
        var sel = $('[data-ts-sort]', root);
        if (sel && !p.has('sort_by')) p.set('sort_by', sel.value);
        return form.getAttribute('action') + '?' + p.toString();
      }

      var form = $('[data-ts-facets]', root), timer;
      if (form) {
        form.addEventListener('change', function (e) {
          if (mqMobile.matches) return;
          if (e.target.hasAttribute('data-ts-price-in')) return;
          clearTimeout(timer);
          timer = setTimeout(function () { load(formUrl(form), true); }, 150);
        });
        $$('[data-ts-price-in]', form).forEach(function (inp) {
          inp.addEventListener('change', function () { if (!mqMobile.matches) load(formUrl(form), true); });
        });
        form.addEventListener('submit', function (e) { e.preventDefault(); load(formUrl(form), true); });
      }
      var sort = $('[data-ts-sort]', root);
      if (sort) sort.addEventListener('change', function () {
        if (form) { load(formUrl(form), true); return; }
        var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); load(u.toString(), true);
      });

      if (root._tsBound) return;
      root._tsBound = true;
      root.addEventListener('click', function (e) {
        var fm = e.target.closest('[data-ts-fg-more]');
        if (fm) {
          var ul = fm.previousElementSibling;
          var open = ul && ul.classList.toggle('is-open');
          fm.textContent = open ? 'Ver menos' : fm.getAttribute('data-label');
          return;
        }
        var a = e.target.closest('.ts-chip, .ts-clear');
        if (a && root.contains(a)) { e.preventDefault(); load(a.href, true); return; }
        if (e.target.closest('[data-ts-side-open]')) { root.classList.add('is-side'); document.documentElement.classList.add('ts-lock'); return; }
        if (e.target.closest('[data-ts-side-close]')) { root.classList.remove('is-side'); document.documentElement.classList.remove('ts-lock'); return; }
        var more = e.target.closest('[data-ts-more]');
        if (more) {
          e.preventDefault();
          if (more.getAttribute('aria-busy') === 'true') return;
          more.textContent = 'Cargando…';
          more.setAttribute('aria-busy', 'true');
          var u = new URL(more.href, window.location.origin);
          u.searchParams.set('section_id', sid);
          fetch(u.toString(), { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var d = document.createElement('div');
              d.innerHTML = html;
              var grid = $('[data-ts-grid]', root), ng = d.querySelector('[data-ts-grid]'), wrap = $('[data-ts-more-wrap]', root), nw = d.querySelector('[data-ts-more-wrap]');
              if (grid && ng) while (ng.firstElementChild) grid.appendChild(ng.firstElementChild);
              if (wrap && nw) wrap.innerHTML = nw.innerHTML;
            })
            .catch(function () { window.location.href = more.href; });
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-side')) { root.classList.remove('is-side'); document.documentElement.classList.remove('ts-lock'); }
      });
    });
  }
  window.addEventListener('popstate', function () {
    if (window.tsPushed && document.querySelector('[data-ts-coll]')) window.location.reload();
  });

  /* ---------- Página del carrito ---------- */
  function initCartPage(scope) {
    $$('[data-ts-cartpage]', scope).forEach(function (root) {
      if (root._tsBound) return;
      root._tsBound = true;
      var sid = root.getAttribute('data-section');
      function msg(t) { var m = $('[data-ts-cart-pmsg]', root); if (m) { m.textContent = t || ''; m.hidden = !t; } }
      function swap(html) {
        var d = document.createElement('div');
        d.innerHTML = html || '';
        var n = d.querySelector('[data-ts-cartpage]');
        if (!n) return;
        root.innerHTML = n.innerHTML;
        root.setAttribute('data-count', n.getAttribute('data-count'));
        setCount(n.getAttribute('data-count'));
        initRows(root);
      }
      function reload() {
        fetch((cfg.root || '/') + 'cart?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j && j[sid]) swap(j[sid]); })
          .catch(function () {});
      }
      document.addEventListener('ts:cart-updated', reload);
      function change(key, qty) {
        root.classList.add('is-loading');
        fetch(cfg.cartChange + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: sid })
        })
          .then(jsonResponse)
          .then(function (res) {
            if (!res.ok) { msg(res.j.description || res.j.message || 'No se pudo actualizar el carrito.'); return; }
            if (res.j.sections && res.j.sections[sid]) swap(res.j.sections[sid]); else window.location.reload();
          })
          .catch(function () { msg('Revisa tu conexión e inténtalo de nuevo.'); })
          .then(function () { root.classList.remove('is-loading'); });
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ts-cq]');
        if (!b || !root.contains(b)) return;
        var line = b.closest('[data-key]');
        if (line) change(line.getAttribute('data-key'), parseInt(b.getAttribute('data-ts-cq'), 10));
      });
      root.addEventListener('change', function (e) {
        if (e.target.matches('[data-ts-cqi]')) {
          var line = e.target.closest('[data-key]');
          var q = Math.max(0, parseInt(e.target.value, 10) || 0);
          if (line) change(line.getAttribute('data-key'), q);
        }
      });
      var nt;
      root.addEventListener('input', function (e) {
        if (!e.target.matches('[data-ts-note]')) return;
        clearTimeout(nt);
        var v = e.target.value;
        nt = setTimeout(function () {
          fetch((cfg.root || '/') + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: v })
          }).catch(function () {});
        }, 600);
      });
    });
  }

  function init(scope) { initRows(scope); initCountdowns(scope); initReveal(scope); initTrust(scope); initPdp(scope); initReco(scope); initColl(scope); initCartPage(scope); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
